import { GraphDateButton } from "./GraphDateButton"
import styles from "./GraphHeader.module.scss"
import { GraphNowButton } from "./GraphNowButton"
import { GraphZoomButton } from "./GraphZoomButton"

export function GraphHeader() {
  return (
    <div className={styles.wrapper}>
      <GraphZoomButton />
      <GraphDateButton />
      <GraphNowButton />
    </div>
  )
}
